



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from "@/definitions";

import { CalendarLayer } from "@/model/document2/page/surface/design/layer/calendarLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { FontManager } from '@/model/fontManager/fontManager';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from "@/commonComponents/adjustedBalloon/adjustedBalloon.vue"

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";
import AlignLeftOn from "../resources/alignLeft_on.vue";
import AlignLeftOff from "../resources/alignLeft_off.vue";
import AlignCenterOn from "../resources/alignCenter_on.vue";
import AlignCenterOff from "../resources/alignCenter_off.vue";
import AlignRightOn from "../resources/alignRight_on.vue";
import AlignRightOff from "../resources/alignRight_off.vue";
import AlignTopOn from "../resources/alignTop_on.vue";
import AlignTopOff from "../resources/alignTop_off.vue";
import AlignMiddleOn from "../resources/alignMiddle_on.vue";
import AlignMiddleOff from "../resources/alignMiddle_off.vue";
import AlignBottomOn from "../resources/alignBottom_on.vue";
import AlignBottomOff from "../resources/alignBottom_off.vue";

import { DebugHelper } from "@/helper/debugHelper";
import { DateHelper } from "@/helper/dateHelper";
import { ResourceHelper } from "@/helper/resourceHelper";


@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    DropdownList,
    FontSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
    AlignLeftOn,
    AlignLeftOff,
    AlignCenterOn,
    AlignCenterOff,
    AlignRightOn,
    AlignRightOff,
    AlignTopOn,
    AlignTopOff,
    AlignMiddleOn,
    AlignMiddleOff,
    AlignBottomOn,
    AlignBottomOff
  }
})

export default class CalendarYearStyle extends Vue
{
    @Prop() private layer!: CalendarLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onChangingValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }
    private onChangedValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private onChangingColor(color, tag)
    {
        this.changeLayerProperty(color, tag, false);
    }

    private onChangedColor(color, tag)
    {
        this.changeLayerProperty(color, tag, true);
    }

    // 表示
    private get yearTypeText()
    {
        var str = DateHelper.getYearString(this.layer.yearType, this.layer.year, this.layer.month, 1);
        return str != "" ? str : "(なし)";
    }
    isYearDropdownVisible = false;
    static readonly yearTypeArray = [0,1,6,3,7,4];
    private get yearDropdownItems()
    {
        var items = new Array();
        for(var i = 0; i < CalendarYearStyle.yearTypeArray.length; ++i)
        {
            var type = CalendarYearStyle.yearTypeArray[i];
            var str = DateHelper.getYearString(type, this.layer.year, this.layer.month, 1);
            items.push({
                id : type,
                isSelected : type == this.layer.yearType,
                label : str != "" ? str : "(なし)"
            });
        }
        return items;
    }
    private setYearType(type: number, tag: string)
    {
        this.isYearDropdownVisible = false;
        this.changeLayerProperty(type, "yearType", true, true);
    }

    // フォント
    private isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private get selectedFontId() { return this.layer.yearFontId; }
    private getFontManager() : FontManager { return this.$store.getters.fontManager; }
    private onSelectFont(fontId: string)
    {
        this.changeLayerProperty(fontId, "yearFontId", true, true);
    }

    // 開閉のアニメーション
    // TODO Props
    openStatus = {
        opend: true
    };

    calendarYearTransformContentsOpenAnimate = false;
    calendarYearTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.calendarYearTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.calendarYearTransformContentsCloseAnimate = false;
            this.calendarYearTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.calendarYearTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.calendarYearTransformContentsOpenAnimate = false;
        }, 250);
        }
    }

    // カラーピッカー表示非表示
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get calendarYearTransformOpendStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0 && this.openStatus.opend){
            style = {
                height: "calc(272% / 752 * 100) !important"
            };
        }
        return style;
    }

    private get commonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "17.7%"
            };
        }
        return style;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
